import { useDispatch, useSelector } from 'react-redux';
import { notificationSnackbarsSelector } from 'src/state/notification/notificationSelectors';
import { useSnackbar } from 'notistack';
import React, { useCallback, useEffect, useRef } from 'react';
import { snackbarActions } from 'src/state/notification/notificationActions';

export const StoreSnackbarController = () => {
  const dispatch = useDispatch();
  const notifications = useSelector(notificationSnackbarsSelector);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const displayed = useRef<string[]>([]);

  const storeDisplayed = useCallback((id: string) => {
    displayed.current = [...displayed.current, id];
  }, []);

  const removeDisplayed = useCallback((id: string) => {
    displayed.current = [...displayed.current.filter((key) => id !== key)];
  }, []);

  useEffect(() => {
    notifications.forEach(
      ({ key, message, options = {}, dismissed = false }) => {
        if (dismissed) {
          closeSnackbar(key);
          return;
        }

        if (displayed.current.includes(key)) return;

        enqueueSnackbar(message, {
          key,
          ...options,
          onClose: (event, reason, myKey) => {
            options.onClose?.(event, reason, myKey);
          },
          onExited: (event, key) => {
            dispatch(snackbarActions.removeSnackbar({ key: `${key}` }));
            removeDisplayed(`${key}`);
          },
        });

        storeDisplayed(key);
      }
    );
  }, [notifications, closeSnackbar, enqueueSnackbar, dispatch]);

  return <></>;
};
